
<template>
  <div class="admin-view">
    <NavigationView />
    <div class="page">
      <div class="page-header">
        <div>
          <div class="page-title">รายการประชุม</div>
        </div>
        <v-btn color="secondary" depressed large class="cta-button" @click="add">
          <v-icon left>mdi-plus</v-icon>
          สร้างการประชุม
        </v-btn>
      </div>

      <v-card class="data-card">
        <div class="data-card-toolbar">
          <span class="data-card-count">ทั้งหมด {{ items.length }} รายการ</span>
          <v-text-field
            v-model="search"
            class="search-field"
            prepend-inner-icon="mdi-magnify"
            placeholder="ค้นหาชื่อการประชุม"
            outlined
            dense
            rounded
            hide-details
            clearable
          ></v-text-field>
        </div>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            sort-by="id"
            :sort-desc="true"
            :loading="loading"
            loading-text="กำลังโหลด..."
            no-data-text="ยังไม่มีการประชุม"
            no-results-text="ไม่พบการประชุมที่ค้นหา"
            :items-per-page="10"
            class="data-table"
            >
            <!-- มือถือ: แสดงแต่ละการประชุมเป็นการ์ดสั้นๆ แทนตาราง -->
            <template v-if="isMobile" v-slot:item="{ item }">
              <tr class="m-row">
                <td colspan="4">
                  <div class="m-title">{{ item.title }}</div>
                  <div class="m-time">
                    <v-icon small color="primary">mdi-calendar-clock</v-icon>
                    {{ shortDateTime(item.startdate) }} – {{ shortDateTime(item.enddate) }}
                  </div>
                  <div class="m-actions">
                    <v-btn small text color="primary" @click="genQR(item)">
                      <v-icon small left>mdi-qrcode</v-icon>QR
                    </v-btn>
                    <v-btn small text color="primary" @click="listparticipants(item)">
                      <v-icon small left>mdi-account-group</v-icon>ผู้เข้าร่วม
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon small color="primary" aria-label="แก้ไข" @click="edit(item)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small color="error" aria-label="ลบ" @click="remove(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
            <template slot="item.actions" slot-scope="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="genQR(item)">
                    <v-icon small>mdi-qrcode</v-icon>
                  </v-btn>
                </template>
                <span>QR ลงทะเบียน</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="listparticipants(item)">
                    <v-icon small>mdi-account-group</v-icon>
                  </v-btn>
                </template>
                <span>ผู้เข้าร่วม</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="edit(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>แก้ไข</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="remove(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>ลบ</span>
              </v-tooltip>
            </template>
        </v-data-table>
      </v-card>
    </div>
    <v-dialog v-model="editmeetingdialog" max-width="700px" :fullscreen="isMobile" :persistent="editSaving">
      <v-card>
        <v-card-title>
          <span class="headline dialog-title">แก้ไขการประชุม</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <meeting-type-picker v-model="EditData.Type"></meeting-type-picker>
                </v-flex>
                <v-flex md12 xs12>
                  <v-text-field
                    v-model="EditData.Title"
                    name="Title"
                    label="ชื่อการประชุม"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="v-scale-transition"
                    v-model="StartDate"
                    offset-y
                    full-width
                    :nudge-left="40"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field lazy v-on="on" label="วันที่เริ่ม" v-model="EditData.StartDate"  prepend-icon="mdi-calendar" readonly></v-text-field>
                    </template>
                    <v-date-picker v-model="EditData.StartDate" color="primary" scrollable>
                      <v-spacer></v-spacer>
                        <v-btn 
                          text 
                          @click="StartDate = false">
                          OK
                        </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md6 xs12>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="v-scale-transition"
                    v-model="StartTime"
                    offset-y
                    full-width
                    :nudge-left="40"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field 
                        lazy 
                        v-on="on" 
                        label="เวลาเริ่ม" 
                        v-model="EditData.StartTime" 
                        prepend-icon="mdi-clock" 
                        readonly>
                      </v-text-field>
                    </template>
                    <v-time-picker v-model="EditData.StartTime" format="24hr" color="primary" scrollable>
                      <v-spacer></v-spacer>
                        <v-btn 
                          text 
                          @click="StartTime = false">
                          OK
                        </v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex md6 xs12>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="v-g-transition"
                    v-model="EndDate"
                    offset-y
                    full-width
                    :nudge-left="40"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field lazy v-on="on" label="วันที่สิ้นสุด" v-model="EditData.EndDate"  prepend-icon="mdi-calendar" readonly></v-text-field>
                    </template>
                    <v-date-picker v-model="EditData.EndDate" :min="EditData.StartDate || undefined" color="primary" scrollable> 
                      <v-spacer></v-spacer>
                        <v-btn 
                          text 
                          @click="EndDate = false">
                          OK
                        </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md6 xs12>
                  <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="v-scale-transition"
                    v-model="EndTime"
                    offset-y
                    full-width
                    :nudge-left="40"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field 
                        lazy 
                        v-on="on" 
                        label="เวลาสิ้นสุด" 
                        v-model="EditData.EndTime" 
                        prepend-icon="mdi-clock" 
                        readonly>
                      </v-text-field>
                    </template>
                    <v-time-picker v-model="EditData.EndTime" :min="editEndTimeMin" format="24hr" color="primary" scrollable>
                      <v-spacer></v-spacer>
                        <v-btn 
                          text 
                          @click="EndTime = false">
                          OK
                        </v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex md12 xs12>
                  <meeting-field-picker v-model="EditData.Fields" :is-admin="getUser.admin === 1"></meeting-field-picker>
                  <div class="field-note">การเปลี่ยนแปลงมีผลกับผู้ที่ลงทะเบียนหลังจากนี้ และต้องบันทึก QR Code ใหม่</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="editSaving" @click="closeDialog">ยกเลิก</v-btn>
          <v-btn color="primary" depressed :disabled="editSaving" @click="updateItem">
            {{ editSaving ? 'กำลังบันทึก...' : 'บันทึก' }}
          </v-btn>
        </v-card-actions>

        <!-- กำลังบันทึก: นกบินวน · สำเร็จ = วนครบรอบแล้วจางหาย แล้วค่อยขึ้น QR ใหม่ -->
        <v-overlay absolute :value="editSaving" :dark="false" color="#FFFFFF" opacity="0.92">
          <div class="saving-overlay">
            <bird-orbit :size="120" :finishing="editBirdFinishing" @done="onEditBirdDone"></bird-orbit>
            <div class="saving-title">กำลังบันทึกการแก้ไข...</div>
            <div class="saving-hint">กรุณารอสักครู่</div>
          </div>
        </v-overlay>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deletemeetingdialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline dialog-title">ยืนยันการลบ</span>
        </v-card-title>
        <v-card-text>
          คุณต้องการลบการประชุม "{{ DataToDelete && DataToDelete.title }}" ใช่หรือไม่
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDeleteDialog">ยกเลิก</v-btn>
          <v-btn color="error" depressed @click="deleteItem()">ลบ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="qrcodemeeting" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline dialog-title">QR Code ลงทะเบียน</v-card-title>
        <v-card-text style="text-align: center;">
          <v-alert v-if="qrAfterEdit" type="success" text dense class="text-left">
            แก้ไขข้อมูลสำเร็จ กรุณาบันทึก QR Code ใหม่นี้แทน QR เดิม
          </v-alert>
          <img
              :src="qrcodeUrl"
              width="200"
              height="200"
              alt="QR Code"
            />
          <qr-instructions :type="qrType"></qr-instructions>
          <v-text-field
            v-model="qrLink"
            label="ลิงก์ลงทะเบียน"
            :value="qrLink">
          </v-text-field>
          <v-btn color="primary" depressed @click="saveQrCode()">
            <v-icon left>mdi-download</v-icon>
            บันทึก QR Code
          </v-btn>
          <!-- โหมดฉายหน้าห้อง (ปิดไว้ก่อน เปิดใช้: เอา comment ออกทั้งปุ่ม แท็ก <present-qr> import และ components)
          <v-btn color="secondary" depressed class="cta-button ml-2" @click="presentOpen = true">
            <v-icon left>mdi-projector-screen</v-icon>
            ฉายหน้าห้อง
          </v-btn> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeQRModal()">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="participants" max-width="560px" persistent :fullscreen="isMobile">
      <v-card>
        <v-card-title class="headline dialog-title">ผู้เข้าร่วมประชุม</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="exportToExcel">
            <v-icon left>mdi-microsoft-excel</v-icon>
            Export Excel
          </v-btn>
        </v-card-actions>
        <v-card-text style="text-align: center;">
            <v-data-table
              :headers="headerParticipants"
              :items="participantRows"
              no-data-text="ยังไม่มีผู้ลงทะเบียน"
            ></v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeListModal()">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <!-- <present-qr v-model="presentOpen" :link="qrLink" :title="qrTitle" :meeting-id="QRid"></present-qr> -->
  <FooterView></FooterView>
  </div>
  
 
   
</template>
  
  
<script>
import axios from 'axios';

import { API_URL } from '@/config';
import { DEFAULT_FIELDS, fieldsOf, buildThaidLink, exportColumns, withRequired } from '@/meetingFields';
import { endTimeMin, isEndDateBeforeStart, isEndTimeBeforeStart } from '@/dateRange';
import NavigationView from '../../components/Navigation.vue'
import FooterView from '../../components/Footer.vue';
import MeetingFieldPicker from '../../components/MeetingFieldPicker.vue';
import QrInstructions from '../../components/QrInstructions.vue';
import MeetingTypePicker from '../../components/MeetingTypePicker.vue';
import BirdOrbit from '../../components/BirdOrbit.vue';
import { DEFAULT_TYPE, typeOf, qrHeadline } from '@/meetingType';
// import PresentQr from '../../components/PresentQr.vue';
import { downloadQrPoster } from '@/qrPoster';
import { mapGetters } from 'vuex';
import QRCode from 'qrcode';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

//   import TableHeaderButtons from '../../components/TableHeaderButtons.vue'
//   import SearchPanel from '../../components/SearchPanel.vue';
//   import ConfirmDialog from '../../components/ConfirmDialog.vue';
export default {
  name: 'ListMeetingView',
  components: {
    NavigationView,
    FooterView,
    MeetingFieldPicker,
    MeetingTypePicker,
    BirdOrbit,
    QrInstructions
    // PresentQr

  //   ConfirmDialog,
  //   SearchPanel

  },
  data() {
      return {
        headers: [
            { text: 'ชื่อการประชุม', value: 'title' },
            { text: 'เริ่ม', value: 'startdate', filterable: false },
            { text: 'สิ้นสุด', value: 'enddate', filterable: false },
            { text: 'จัดการ', value: 'actions', sortable: false, filterable: false, align: 'end' }
        ],
        search: '',
        participantFields: DEFAULT_FIELDS.slice(),
        participantTitle: '',
        items: [],
        itemsParticipants:[],
        loading: true,
        pagination: {
            page: 1,
            rowsPerPage: 10,
        },
        editmeetingdialog: false,
        deletemeetingdialog: false,
        EditData: {
          id: null,
          Type: DEFAULT_TYPE,
          Title: '',
          StartDate: '',
          StartTime: '',
          EndDate: '',
          EndTime: '',
          Fields: DEFAULT_FIELDS.slice()
        },
        StartDate: false,
        EndDate: false,
        StartTime: false,
        EndTime: false,
        DataToDelete: null,
        qrcodemeeting: false,
        presentOpen: false,
        qrAfterEdit: false,
        QRid: null,
        qrTitle: '',
        qrType: DEFAULT_TYPE,
        editSaving: false,
        editBirdFinishing: false,
        editSavedFields: null,
        participants: false,
        qrLink: '',
        qrcodeUrl: '',
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    editEndTimeMin() {
      return endTimeMin(this.EditData.StartDate, this.EditData.StartTime, this.EditData.EndDate);
    },
    // หน้าต่างรายชื่อ: แสดงแค่ชื่อกับเวลา (ข้อมูลอื่น เช่น เลขบัตร ดูได้ใน Excel เท่านั้น)
    // การประชุมที่ไม่ได้เก็บชื่อ แสดงลำดับแทน
    headerParticipants() {
      const first = this.participantFields.indexOf('name') !== -1
        ? { text: 'ชื่อ', value: 'name' }
        : { text: 'ลำดับ', value: 'no' };
      return [first, { text: 'เวลา', value: 'timestamp' }];
    },
    participantRows() {
      return this.itemsParticipants.map((p, i) => ({ no: i + 1, name: p.name, timestamp: p.timestamp }));
    },
  },
  watch: {
    // เปลี่ยนวันเวลาเริ่มจนวันเวลาสิ้นสุดเดิมอยู่ก่อนหน้า: ล้างค่าสิ้นสุดให้เลือกใหม่
    'EditData.StartDate'() { this.clearInvalidEnd(); },
    'EditData.StartTime'() { this.clearInvalidEnd(); },
    'EditData.EndDate'() { this.clearInvalidEnd(); },
  },
  mounted() {
    // มาจากปุ่ม "จัดการ" ในปฏิทิน: ค้นหาการประชุมนั้นให้เลย
    if (this.$route.query.search) {
      this.search = String(this.$route.query.search);
    }
    this.fetchData();
    // if (!this.$store.state.user) {
    //   this.$router.push('/login');
    // }
  },
  methods: {
    // "2026-10-15 12:00:00" -> "15 ต.ค. 69 12:00" (ใช้ในการ์ดบนมือถือ)
    shortDateTime(value) {
      if (!value) return '-';
      const [date, time] = String(value).split(' ');
      const d = new Date(`${date}T00:00:00`);
      if (isNaN(d)) return value;
      const day = new Intl.DateTimeFormat('th-TH', { day: 'numeric', month: 'short', year: '2-digit' }).format(d);
      return time ? `${day} ${time.slice(0, 5)}` : day;
    },
    clearInvalidEnd() {
      const d = this.EditData;
      if (isEndDateBeforeStart(d.StartDate, d.EndDate)) {
        d.EndDate = '';
        d.EndTime = '';
      } else if (isEndTimeBeforeStart(d.StartDate, d.StartTime, d.EndDate, d.EndTime)) {
        d.EndTime = '';
      }
    },
    async fetchData() {
        try {  
          const response = await axios.get(`${API_URL}/getmeeting/${this.getUser.id}`);  
          this.items = response.data.result; 
          this.loading = false;
        } catch (error) {
          console.error("Error fetching data:", error);
          this.loading = false;
        }
    },
    add() {
        this.$router.push('CreateMeeting');
    },
    edit(item) {      
      this.EditData.id = item.id;
      this.EditData.Type = typeOf(item.type);
      this.EditData.Title = item.title;

      const [startdate, starttime] = item.startdate.split(' ');
      this.EditData.StartDate = startdate;
      this.EditData.StartTime = starttime.slice(0, 5); 

      const [enddate, endtime] = item.enddate.split(' ');
      this.EditData.EndDate = enddate;
      this.EditData.EndTime = endtime.slice(0, 5); 

      // ชื่อ-นามสกุลบังคับ: การประชุมเก่าที่ไม่มีชื่อจะถูกติ๊กให้
      this.EditData.Fields = withRequired(fieldsOf(item));

      this.editmeetingdialog = true;

    },
    closeDialog() {
      this.editmeetingdialog = false; 
    },
    remove(item) {
      this.DataToDelete = item;
      this.deletemeetingdialog = true; 
    },
    closeDeleteDialog() {
      this.deletemeetingdialog = false; 
    },
    // afterEdit: เปิดหลังบันทึกการแก้ไข ใช้ fields ที่ backend บันทึกจริง และเตือนให้บันทึก QR ใหม่
    genQR(item, fields, afterEdit){
      this.qrcodemeeting = true;
      this.qrAfterEdit = !!afterEdit;
      let imgQRLink = buildThaidLink(item.id, fields || fieldsOf(item));
      this.qrLink = imgQRLink;
      this.QRid = item.id;
      this.qrTitle = item.title;
      this.qrType = typeOf(item.type);
      QRCode.toDataURL(imgQRLink, (err, url) => {
        if (err) {
          console.error(err);
          return;
        }
        
        this.qrcodeUrl = url;
      });          
    },
    async listparticipants(item){  
      this.participants = true;
      this.participantFields = fieldsOf(item);
      this.participantTitle = item.title;
      this.itemsParticipants = [];
      try {
        const response = await axios.get(`${API_URL}/participants/${item.id}`);
        // ยังไม่มีผู้ลงทะเบียน backend จะไม่ส่ง result มา: ใช้รายการว่างแทน
        this.itemsParticipants = response.data.result || [];
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      // try {
      //     const response = axios.get('http://localhost:3002/participants/${this.item.id}');   
      //     console.log(response);
          
      //     // this.items = response.data.result; 
      //   } catch (error) {
      //     console.error("Error data:", error);
      //     this.loading = false;
      //   }
        
        // .then(response => {
        //   if (response.data.responsecode == 200){
        //     Swal.fire({
        //       type: "success",
        //       title: "แก้ไขข้อมูลสำเร็จ",
        //       icon: "success",
        //       confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
        //     });
        //   }
        //   else {
        //     Swal.fire({
        //       title: "แก้ไขข้อมูลไม่สำเร็จ",
        //       icon: "warning",
        //       confirmButtonText: '<span style="padding: 15px">ปิด</span>',
        //     });

        //   }
        //   this.closeDialog(); 
        //   this.fetchData();
        // })
        // .catch(error => {
        //   console.error('Error updating item:', error);
        // });
          
    },
    closeQRModal(){
      this.qrcodemeeting = false;
    },
    closeListModal(){
      this.participants = false;
    },
    // นกวนครบรอบและจางหายแล้ว: ปิดหน้าต่างแก้ไข แล้วเด้ง QR ใหม่ให้บันทึกทันที (ข้อมูลที่เก็บอาจเปลี่ยน QR เดิมจึงไม่ตรง)
    onEditBirdDone() {
      this.editSaving = false;
      this.editBirdFinishing = false;
      this.closeDialog();
      this.fetchData();
      this.genQR({ id: this.EditData.id, title: this.EditData.Title, type: this.EditData.Type }, this.editSavedFields || this.EditData.Fields, true);
    },
    updateItem() {
      if (this.editSaving) return;
      this.editSaving = true;
      axios.put(`${API_URL}/editmeeting/${this.EditData.id}`, { ...this.EditData, UserId: this.getUser.id })
        .then(response => {
          if (response.data.responsecode == 200){
            this.editSavedFields = response.data.data && response.data.data.fields;
            this.editBirdFinishing = true;
          }
          else {
            this.editSaving = false;
            // ไม่ปิดหน้าต่าง เพื่อให้แก้ต่อได้โดยข้อมูลที่กรอกไม่หาย
            Swal.fire({
              title: "แก้ไขข้อมูลไม่สำเร็จ",
              text: response.data.message,
              icon: "warning",
              confirmButtonText: '<span style="padding: 15px">ปิด</span>',
            });
          }
        })
        .catch(error => {
          this.editSaving = false;
          console.error('Error updating item:', error);
        });
    },
    deleteItem() {
      
      axios.put(`${API_URL}/deletemeeting/${this.DataToDelete.id}`, this.DataToDelete)
        .then(response => {
          if (response.data.responsecode == 200){
            Swal.fire({
              type: "success",
              title: "ลบข้อมูลสำเร็จ",
              icon: "success",
              confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
            });
          }
          else {
            Swal.fire({
              title: "ลบข้อมูลไม่สำเร็จ",
              icon: "warning",
              confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
            });

          }
          this.closeDeleteDialog(); 
          this.fetchData();
        })
        .catch(error => {
          console.error('Error updating item:', error);
        });
    },

    // ดาวน์โหลดเป็นรูปพร้อมชื่อการประชุมและวิธีสแกน (พิมพ์ติดหน้าห้องได้เลย)
    saveQrCode() {
      downloadQrPoster(this.qrLink, this.qrTitle, qrHeadline(this.qrType));
    },
      exportToExcel() {
        // const data = [
        //     { [title]: title }, // เพิ่ม title ที่แถวแรก
        //     ...this.items.map(item => ({
        //         [title]: item.name,  // เพิ่มข้อมูลในแถวถัดไป
        //     }))
        // ];
        // เฉพาะคอลัมน์ที่การประชุมนี้เลือกเก็บ + เวลาที่ลงทะเบียน
        const columns = exportColumns(this.participantFields);
        const data = this.itemsParticipants.map(item => {
          const row = {};
          columns.forEach(c => { row[c.header] = item[c.value]; });
          row['Time'] = item.timestamp;
          return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // ตั้งชื่อไฟล์ตามชื่อการประชุม (ตัดอักขระที่ใช้เป็นชื่อไฟล์ไม่ได้ออก)
        const safeTitle = (this.participantTitle || '').replace(/[\\/:*?"<>|]/g, ' ').replace(/\s+/g, ' ').trim();
        XLSX.writeFile(workbook, `${safeTitle || 'Export'}.xlsx`);
    }
    
  },
}
</script>

<style scoped>
.v-navigation-drawer {
  width: 200px;
}

.field-note {
  margin-top: 8px;
  color: #5B6B7F;
  font-size: 13px;
}

.v-card-title {
  background-color: #4CAF50;
  color: white;
}

.v-card-subtitle {
  margin-bottom: 20px;
}

.v-text-field {
  margin-bottom: 20px;
}

.saving-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.saving-title {
  margin-top: 20px;
  color: #0C2F53;
  font-size: 18px;
  font-weight: 600;
}

.saving-hint {
  margin-top: 4px;
  color: #5B6B7F;
  font-size: 14px;
}

.m-title {
  color: #0C2F53;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.4;
  word-break: break-word;
}

.m-time {
  margin-top: 4px;
  color: #5B6B7F;
  font-size: 14px;
}

.m-actions {
  display: flex;
  align-items: center;
  margin: 6px -8px 0;
}
</style>

<!-- ไม่ใช้ scoped: แถว/ช่องแรกของตารางอาจเป็น element เดิมที่ Vuetify สร้างไว้ ซึ่งไม่มี attribute ของ scoped style -->
<style>
.data-table tr.m-row,
.data-table tr.m-row > td {
  display: block;
  width: 100%;
}

.data-table tr.m-row > td {
  padding: 14px 16px 6px !important;
  height: auto !important;
  border-bottom: 1px solid #E8EDF3;
}
</style>
  